import { UserPermission } from '@globaleris/ui.library'
import { UserModule } from '../model/enums/userModules'
import { Pages, Routes } from '../model/RBAC/constants'
import { UserStoreModel } from '../redux'
import { store } from '../redux/store'

export const getUserPermissions = (page: Pages): UserPermission[] => {
  const user: UserStoreModel | undefined = store.getState().profile.user

  if (user?.isSuperUser) {
    return [UserPermission.EDIT, UserPermission.READ_ONLY, UserPermission.SEND, UserPermission.INFO]
  }

  let userPermissions: UserPermission[] = []
  user &&
    user.roles
      .filter(x => x.resources.filter(y => Routes.get(page)?.resource.includes(y.id)))
      .forEach(rol => {
        rol.resources
          .filter(x => Routes.get(page)?.resource.includes(x.id))
          .forEach(resource => {
            resource.edit && userPermissions.push(UserPermission.EDIT)
            resource.readOnly && userPermissions.push(UserPermission.READ_ONLY)
            resource.send && userPermissions.push(UserPermission.SEND)
            resource.info && userPermissions.push(UserPermission.INFO)
          })
      })

  return [...new Set(userPermissions)]
}

export const getResourceUserPermissions = (resource: number): UserPermission[] => {
  const user: UserStoreModel | undefined = store.getState().profile.user

  if (user?.isSuperUser) {
    return [UserPermission.EDIT, UserPermission.READ_ONLY, UserPermission.SEND, UserPermission.INFO]
  }

  let userPermissions: UserPermission[] = []
  user &&
    user.roles
      .filter(x => x.resources.filter(y => y.id === resource))
      .forEach(rol => {
        rol.resources
          .filter(x => x.id === resource)
          .forEach(resource => {
            resource.edit && userPermissions.push(UserPermission.EDIT)
            resource.readOnly && userPermissions.push(UserPermission.READ_ONLY)
            resource.send && userPermissions.push(UserPermission.SEND)
            resource.info && userPermissions.push(UserPermission.INFO)
          })
      })

  return [...new Set(userPermissions)]
}

export const getResourcesUserPermissions = (resource: number[]): UserPermission[] => {
  const user: UserStoreModel | undefined = store.getState().profile.user

  if (user?.isSuperUser) {
    return [UserPermission.EDIT, UserPermission.READ_ONLY, UserPermission.SEND, UserPermission.INFO]
  }

  let userPermissions: UserPermission[] = []
  user &&
    user.roles
      .filter(x => x.resources.filter(y => resource.includes(y.id)))
      .forEach(rol => {
        rol.resources
          .filter(x => resource.includes(x.id))
          .forEach(resource => {
            resource.edit && userPermissions.push(UserPermission.EDIT)
            resource.readOnly && userPermissions.push(UserPermission.READ_ONLY)
            resource.send && userPermissions.push(UserPermission.SEND)
            resource.info && userPermissions.push(UserPermission.INFO)
          })
      })

  return [...new Set(userPermissions)]
}

export const hasPermission = (resource: number, permissions: UserPermission[]): boolean => {
  const intersection = getResourceUserPermissions(resource).filter(
    element => permissions.indexOf(element) !== -1
  )

  return intersection && intersection.length > 0
}

export const hasRole = (role: string): boolean => {
  const user: UserStoreModel | undefined = store.getState().profile.user
  let roles = user && user.roles.filter(x => x.description.includes(role))
  return !(typeof roles === 'undefined' || roles === null || roles.length == 0)
}

export const hasResource = (resourceId: number): boolean => {
  const resource = getResourceUserPermissions(resourceId)
  return resource.length > 0
}

export const getUserModules = (): UserModule[] => {
  const user: UserStoreModel | undefined = store.getState().profile.user

  let modules: UserModule[] = []

  user?.roles.forEach(role => {
    const moduleString = role.description.match(/[A-Z]*[^A-Z]+/g)?.[0]
    const moduleName = moduleString?.toUpperCase() as UserModule
    if (moduleName && Object.values(UserModule).includes(moduleName)) {
      modules.push(moduleName)
    }
  })

  return [...new Set(modules)] as UserModule[]
}
